import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const customer360Service = {
  getCustomer360,
  statementPdf,
}

export function getCustomer360(debtorCode) {
  return apiHelper(API_URL).get(`/customers/${encodeURIComponent(debtorCode)}/360`)
}

export function statementPdf(debtorCode) {
  return apiHelper(API_URL).get(`/customers/${encodeURIComponent(debtorCode)}/statement-pdf`, {
    responseType: 'blob',
  })
}
